import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/cursive/',
  headTitle: 'Free Cursive Font Generator',
  headDescription:
    'Looking for an easy-to-use and free cursive font generator? Picsart can help you transform your text with elegant cursive fonts in seconds.',
  heading: 'Stylize Your Text with Picsart Cursive Font Generator',
  description:
    'For both formal and informal purposes, choose your favorite cursive font to add a touch of class to your text.',
  selectedCategory: FontCategory.Cursive,
  inputPlaceholder: 'Make here your text cursive…',
  landingText: {
    imageSection: [
      {
        imgSrc: 'https://cdn140.picsart.com/31449373374882053342.webp',
        imgAlt: 'cursive font generator',
        imageWidth: 355,
        imageRight: false,
        title: 'All You Need to Know About Cursive Fonts',
        children: {
          paragraph: `Cursive fonts are among the oldest fonts still in common use today. Dating back to the days when writers used ink quills to write their letters, cursive fonts are defined by their flowing scripts and often connected letters and words. This happens because cursive fonts are often created without lifting a pen from the page. In the digital world today, cursive handwriting is mimicked in many font options, including <a className='link--underline' href='https://picsart.com/fonts?style=cursive/' target='_blank'>cursive fonts</a>, to offer a more elegant and traditional alternative to common text fonts like Arial, Calibri, Times New Roman, and more.`,
          additionalText:
            'A cursive font generator can help you transform ordinary text into cursive fonts in a flash, making it easy to create documents or web pages that seem more elegant or formal, or simply stand out from traditional websites or text documents. By simply copying and pasting any text into the Picsart cursive font generator, you can easily transform your copy to fit formal occasions, create elegant presentations, or stylize your website text to impress your viewers. This can be especially useful for creating formal event invitations, designing menus for high-end restaurants or catering companies, and in graphic design projects for companies looking to communicate a sense of style or elegance in their advertising.',
        },
      },
      {
        imgSrc: 'https://cdn140.picsart.com/06350059335479530960.webp',
        imgAlt: 'cursive fonts',
        imageWidth: 253,
        imageRight: true,
        title: 'Why Use the Picsart Cursive Font Generator?',
        children: {
          paragraph:
            'Picsart offers a cursive text generator that makes it easier than ever to transform your text into cursive fonts:',
          list: [
            'There is no payment or registration required to use the cursive font generator, ever.',
            'Simply copy and paste the text you want to transform into cursive fonts into the cursive text generator, choose your favorite cursive font option, and then copy your newly cursive text back into your document or app.',
            'New cursive fonts are added regularly, giving you more and more options to choose from.',
            'No need to download or install any software. Use the cursive font generator as much as you need to with just a few clicks.',
            'Transform your text into cursive fonts in seconds.',
          ],
        },
      },
    ],
    howToSection: {
      title: 'How to use the cursive font generator',
      steps: [
        {
          title: 'Upload Your Text',
          description:
            'Start with the cursive font generator by copying and pasting the text you want to transform into cursive fonts into the tool.',
        },
        {
          title: 'Browse Cursive Fonts',
          description:
            'Experiment with an ever-growing variety of cursive fonts until you find the perfect fit for your purposes.',
        },
        {
          title: 'Copy Your Cursive Text',
          description:
            'After you find the right font in the cursive text generator, simply copy and paste your newly cursive text back into your document, webpage, or app and you are good to go.',
        },
      ],
      cta: 'Get Started!',
    },
    similarTools: {
      paragraph:
        'Looking for additional text tools aside from a cursive font generator? Picsart offers a variety of text editing and transformation tools for your use, all completely free.',
    },
    moreInfo: {
      title: 'Need some more info?',
      description: 'Picsarts friendly support team will be happy to help.',
      btn: 'Get in touch',
    },
  },
};

export default props;
